import React, { useEffect, useState } from 'react'

function CarouselAbout(){
    
    const [currentIndex, setCurrentIndex] = useState(0);
    const testimonials = [
      {
        text: "“Clevero Technology deserves a 5-star rating for their incredible assistance! I'll definitely be hiring their services for my next project!”",
        author: "Ray Sanchez",
        position: "CEO & Co-Founder, Sen Group"
      },
      {
        text: "“When I urgently needed a responsive website for my business, I discovered Clevero Technology. I'm delighted with the outcome—it surpassed my expectations. Huge thanks to the Clevero Tech team for their consistent support whenever I reached out. I trust I can rely on you in the future too!”",
        author: "Ray Sanchez",
        position: "CEO & Co-Founder, Sen Group"
      }
    ];

    const nextSlide = () => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % testimonials.length);
      };
    
      const prevSlide = () => {
        setCurrentIndex((prevIndex) => (prevIndex - 1 + testimonials.length) % testimonials.length);
      };
    
      useEffect(() => {
        const autoSlide = setInterval(nextSlide, 5000);
    
        return () => clearInterval(autoSlide);
      }, [testimonials.length]);

  return (
    <>
        <div className="w-full carousel-container relative carousel-nav-left carousel-nav-lg carousel-nav-left carousel-dots-mobile-outside carousel-dots-mobile-center yes">
            <div className="-mr-15 -ml-15 carousel-items relative">   
                <div className="carousel-container">
                    <div className="carousel-item-inner" style={{ transform: `translateX(-${currentIndex * 100}%)` }}>
                        {testimonials.map((testimonial, index) => (
                        <div className="carousel-item-content" key={`carousel${index}`}>
                            <p>{testimonial.text}</p>
                            <h5>{testimonial.author}</h5>
                            <span>{testimonial.position}</span>
                        </div>
                        ))}
                    </div>
                    <div className="carousel-controls">
                        <button onClick={prevSlide}  className="flickity-button flickity-prev-next-button previous"  type="button"  aria-label="Previous" disabled={currentIndex === 0} >
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="13.4" viewBox="0 0 16 13.4">
                                <path d="M9.3,1.3,7.9,2.7,12.2,7H0V9H12.2L7.9,13.3l1.4,1.4L16,8Z" transform="translate(16 14.7) rotate(180)"></path>
                            </svg>
                        </button>
                        <div className="lqd-carousel-slides d-flex align-items-center justify-content-center flex items-center justify-center">
                        <div className="lqd-carousel-slides-current d-inline-block overflow-hidden text-center" style={{ width: '20px', whiteSpace: 'nowrap' }}>
                                 <div className="lqd-carousel-slides-current-inner d-inline-block pos-rel" 
                                      style={{ transition: 'transform 0.5s ease', transform: `translateX(-${currentIndex * 20}px)` }}>
                                       {testimonials.map((_, index) => (
                                          <span key={index} className="d-inline-block" style={{ marginTop: '12px', width: '20px', fontSize: '16px', textAlign: 'center', textIndent: index === 0 ? '27px' : '-16px' }}>
                                              {index + 1}
                                          </span>
                                           ))}
                                    </div>

                            </div>
                            <div className="lqd-carousel-slides-about">{testimonials.length}</div>
                        </div>
                        <button onClick={nextSlide}  className="flickity-button flickity-prev-next-button next" type="button" aria-label="Next" disabled={currentIndex === testimonials.length - 1} >
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="13.4" viewBox="0 0 16 13.4">
                                <path d="M9.3,13.4,7.9,12l4.3-4.3H0v-2H12.2L7.9,1.4,9.3,0,16,6.7Z"></path>
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
        </div> 
    </>
  )
}
export default CarouselAbout